module.exports = __webpack_public_path__ + "static/media/study 210728.200d5e4c.png";